export default "__VITE_ASSET__r56cDqUW__"